import { Trash2, X } from "lucide-react";

/**
 * Sticky action bar shown when one or more rows are selected.
 * Props:
 *   count: number of selected ids
 *   total: total visible rows (for "Select all" affordance)
 *   onClear: clear selection
 *   onSelectAll: select every visible row
 *   onDelete: trigger delete action
 *   busy: disable buttons while a request is in-flight
 *   entityLabel: e.g. "medicines", "sales", "vendors"
 */
export default function BulkSelectBar({ count, total, onClear, onSelectAll, onDelete, busy, entityLabel = "entries" }) {
  if (count === 0) return null;
  return (
    <div
      className="sticky top-16 z-10 -mx-6 md:-mx-8 px-6 md:px-8 py-3 bg-[#002FA7] text-white flex items-center gap-3 shadow-sm"
      data-testid="bulk-select-bar"
    >
      <button onClick={onClear} className="p-1 rounded hover:bg-white/15" data-testid="bulk-clear-btn" aria-label="Clear selection">
        <X className="w-4 h-4" />
      </button>
      <span className="text-sm font-medium">
        <span data-testid="bulk-selected-count">{count}</span> {entityLabel} selected
      </span>
      {count < total && (
        <button onClick={onSelectAll} className="text-xs underline opacity-90 hover:opacity-100" data-testid="bulk-select-all-btn">
          Select all {total}
        </button>
      )}
      <div className="ml-auto flex gap-2">
        <button
          onClick={onDelete}
          disabled={busy}
          data-testid="bulk-delete-btn"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-[#B91C1C] hover:bg-[#991B1B] disabled:opacity-50 text-sm font-medium transition-colors"
        >
          <Trash2 className="w-3.5 h-3.5" /> {busy ? "Deleting…" : "Delete selected"}
        </button>
      </div>
    </div>
  );
}
